import { buildUrl } from "../../ReusableFunctions/reusableFunctions";
import { SERVER_URLS } from "../../appConstants";
import { getToken } from "../authentication";

export const getAllFeedPosts = async ({pageSize,pageNumber,searchQuery}) => {
    try {
        const token = getToken();
        const url = buildUrl(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/marketing/feedPosts`, {
            pageSize: pageSize && pageNumber ? pageSize : undefined,
            pageNumber: pageSize && pageNumber ? pageNumber : undefined,
            searchQuery: searchQuery ? searchQuery:undefined
        });
        const response = await fetch(url,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );
        const res = await response.json();
        if (!response.ok) {
            throw (res.message || "Something went wrong while fetching posts");
        }
        return res?.posts || [];
    } catch (err) {
        throw err;
    }
}

export const getPostDetails = async (id) => {
    try {
        const token = getToken();
        const response = await fetch(`${SERVER_URLS.BACKEND_SERVER}/user/feeds/post/${id}`,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token} `,
                    "Content-Type": "application/json"
                },
            }
        );

        const res = await response.json();
        if (!response.ok) {
            throw (res.message || "Something went wrong while setteling the transaction");
        }
        return res;
    } catch (err) {
        throw (err || "Something went wrong while setteling the transaction");
    }
}


export const addFeedPost = async (post) => {
    try {
            const token = getToken();
            const response = await fetch(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/marketing/feedPosts`,
                {
                    method: "POST",
                    body: post,
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
    
            const res = await response.json();
            if (!response.ok) {
                throw (res.message || "Something went wrong while aadding post");
            }
    } catch (err) {
        throw (err)
    }
}

export const deletePost =async(id)=>{
    try {
        const token = getToken();
        const response = await fetch(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/marketing/feedPosts/${id}`,
            {
                method: "DELETE",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        const res = await response.json();
        if (!response.ok) {
            throw (res.message || "Something went wrong while aadding post");
        }
        return res;
        } catch (err) {
            throw (err)
        }
}

export const getAdminPostDetails =async(id)=>{
    try {
        const token = getToken();
        const response = await fetch(`${SERVER_URLS.BACKEND_SERVER}/bhumeet_team/marketing/feedPosts/details/${id}`,
            {
                method: "GET",
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }
        );

        const res = await response.json();
        if (!response.ok) {
            throw (res.message || "Something went wrong while aadding post");
        }
        return res?.details;
        } catch (err) {
            throw (err)
        }
}

